export default {
  title: {
    id: 'myprofile_infos_title',
    defaultMessage: 'My Info',
  },
  verifyEmail: {
    id: 'myprofile_infos_verify_email',
    defaultMessage: 'Verify email',
  },
  emailVerified: {
    id: 'myprofile_infos_email_verified',
    defaultMessage: 'Verified',
  },
  emailVerifiedToastTitle: {
    id: 'myprofile_infos_email_verified_toast_title',
    defaultMessage: 'Email verified',
  },
  emailVerifiedToastContent: {
    id: 'myprofile_infos_email_verified_toast_content',
    defaultMessage: "You're all set!",
  },
  emailUnverified: {
    id: 'myprofile_infos_email_unverified',
    defaultMessage: 'Unverified',
  },
  unlinkSocialAccounts: {
    id: 'myprofile_infos_unlink_social_accounts',
    defaultMessage: 'Remove connected social accounts',
  },
  updatePassword: {
    id: 'myprofile_infos_modify_password',
    defaultMessage: 'Change my password',
  },
  deleteAccount: {
    id: 'myprofile_infos_delete_account',
    defaultMessage: 'Delete your account',
  },
  tooManyEmailVerificationAttemptsErrorTitle: {
    id: 'myprofile_infos_too_many_email_verification_attemtps_error_title',
    defaultMessage: 'Too many email verification attempts.',
  },
  tooManyEmailVerificationAttemptsErrorContent: {
    id: 'myprofile_infos_too_many_email_verification_attempts_error_content',
    defaultMessage: 'Please wait a minute and try again.',
  },
}
